import React, { useEffect } from "react";
import { useLocation, Routes, Route, Navigate } from "react-router-dom";
import WOW from "wow.js";
import CreativeAgency from "./pages/Home/CreativeAgency";
import AboutUs from "./pages/About/AboutUs";
import ContactPage from "./pages/ContactPage";
import AnimatedCursor from "react-animated-cursor";

function App() {
  // WOW.js initialisatie
  useEffect(() => {
    const wow = new WOW({
      boxClass: "wow",
      animateClass: "animated",
      offset: 0,
      mobile: false,
      live: true,
    });
    wow.init();
  }, []);

  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);

    document.body.classList.remove("fix");
    document.body.classList.remove("mobile-menu-visible");
  }, [pathname]);

  return (
    <>
      <AnimatedCursor
        innerSize={8}
        outerSize={32}
        color="248, 158, 82"
        outerAlpha={0.15}
        innerScale={0}
        outerScale={0}
        clickables={[
          "a",
          'input[type="text"]',
          'input[type="email"]',
          'input[type="number"]',
          'input[type="submit"]',
          'input[type="image"]',
          "label[for]",
          "select",
          "textarea",
          "button",
          ".link",
        ]}
      />

      <Routes>
        <Route path="/" element={<CreativeAgency />} />
        <Route path="/over-ons" element={<AboutUs />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/about-us" element={<Navigate to="/over-ons" replace />} />
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    </>
  );
}

export default App;
